import { api } from "../../axios";

export const actions = {

    // Target
    GetTarget(){
        return api.get("Target/GetAllTargets");
    },
    GetMyTarget(context, data){
        return api.get(`Target/MyTarget/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetGroupTargets(context, data){
        return api.get(`Target/Group/DeliveryUnit/${data.cycle}/${data.campusId}`);
    },
    GetTargetByMain(context, data){
        return api.get(`Target/MainTarget/${data}`);
    },
    GetSingleTarget(context, data){
        return api.get(`Target/${data}`);
    },
    GetTargetByDU(context, data){
        return api.get(`Target/DeliveryUnit/${data.cycle}/${data.id}`);
    },
    GetTargetByIndicator(context, data){
        return api.get(`Target/indicator/${data.cycle}/${data.id}`);
    },
    GetDuWithUnPostedTarget(context, data){
        return api.get(`Target/UnPosted/Summary/${data.campusId}/${data.cycle}`);
    },
    GetDuWithPostedTarget(context, data){
        return api.get(`Target/Posted/Summary/${data.campusId}/${data.cycle}`);
    },
    GetDuWithSubmittedTarget(context, data){
        return api.get(`Target/Submitted/Summary/${data.campusId}/${data.cycle}`);
    },
    GetDuWithCompletedTarget(context, data){
        return api.get(`Target/Completed/Summary/${data.campusId}/${data.cycle}`);
    },
    GetDuWithSubmittedAndCompletedTarget(context, data){
        return api.get(`Target/SubmittedAndCompleted/Summary/${data.clusterId}/${data.cycle}`);
    },
    GetUnPostedTargetByDu(context, data){
        return api.get(`Target/UnPosted/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetPostedTargetByDu(context, data){
        return api.get(`Target/Posted/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetSubmittedTargetByDu(context, data){
        return api.get(`Target/Submitted/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetCompletedTargetByDu(context, data){
        return api.get(`Target/Completed/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetSubmittedAndCompletedTargetByDu(context, data){
        return api.get(`Target/SubmittedAndCompleted/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetSimpleCompletedTargetByDu(context, data){
        return api.get(`Target/Submitted/Completed/Simple/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPostedTargetCount(context, data){
        return api.get(`Target/Posted/Count/${data.campusId}/${data.cycle}`);
    },
    GetSubmittedTargetCount(context, data){
        return api.get(`Target/Submitted/Count/${data.campusId}/${data.cycle}`);
    },
    UpdateTarget(context, data){
        return api.put(`Target/${data.id}`, data);
    },
    PostTargetAccomplishment(context, data){
        return api.put(`Target/Accomplishment/Post/${data}`);
    },
    PostTarget(context, data){
        return api.put(`Target/post/${data}`);
    },
    UnPostTarget(context, data){
        return api.put(`Target/UnPost/${data}`);
    },
    SubmitTarget(context, data){
        return api.put(`Target/Submit/${data.id}`, data);
    },
    CompleteTarget(context, data){
        return api.put(`Target/Complete/${data.id}`, data);
    },
    ReturnToPostTarget(context, data){
        return api.put(`Target/Return/${data.id}`, data);
    },
    DeleteTarget(context, data){
        return api.delete(`Target/${data}`);
    },
    CreateTarget(context, data){
        return api.post(`Target/CreateTarget`, data);
    },
    AddInterveningTask(context, data){
        return api.post(`Target/Add/InterveningTarget/${data.deliveryUnitId}/${data.cycle}`, data);
    },

}